export default __webpack_public_path__ + "static/media/PromDate.d1b87069.jpg";